!(function (window, document, undefined) {
    'use strict';

    $.scrollDepth({
        userTiming: false,
        pixelDepth: false,
        nonInteraction: false,
        gtmOverride: true,
    });

    const trackEvent = (selector, event, data, filter = (el, data) => data) => {
        $(selector).on(event, function () {
            filter(this, data)
            gtag('event', event, data);
        });
    };

    const $main = $body.find('main');

    let page = 'home';

    if ($main.is('.-feeed')) {
        page = 'feeed';
    }

    if ($main.is('.-feeed-internal')) {
        page = 'feeed-interna';
    }

    if ($main.is('.-works')) {
        page = 'trabalhos';
    }

    if ($main.is('.-works-internal')) {
        page = 'trabalhos-interna';
    }

    if ($main.is('.-people')) {
        page = 'pessoas';
    }

    trackEvent('#header .-address-1', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'enderecopaulista' });
    trackEvent('#header .-tel-1', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'telefonepaulista' });
    trackEvent('#header .-address-2', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'enderecony' });
    trackEvent('#header .-tel-2', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'telefoneny' });
    trackEvent('#header .-instagram', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'instagram' });
    trackEvent('#header .-linkedin', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'linkedin' });
    trackEvent('#header .-facebook', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'facebook' });
    trackEvent('#header .-email', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'emailcontato' });
    trackEvent('#header .-english', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'englishversion' });
    trackEvent('#header .-portuguese', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'portugueseversion' });
    trackEvent('#header .-home', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'home' });
    trackEvent('#header .-works', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'trabalhos' });
    trackEvent('#header .-people', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'pessoas' });
    trackEvent('#header .-feeed', 'click', { 'event_category': page, 'event_action': 'header', 'event_label': 'feeed' });

    trackEvent('#footer form', 'submit', { 'event_category': page, 'event_action': 'footer', 'event_label': 'emailenviar' });
    trackEvent('#footer .-address-1', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'enderecopaulista' });
    trackEvent('#footer .-tel-1', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'telefonepaulista' });
    trackEvent('#footer .-address-2', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'enderecony' });
    trackEvent('#footer .-tel-2', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'telefoneny' });
    trackEvent('#footer .-instagram', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'instagram' });
    trackEvent('#footer .-linkedin', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'linkedin' });
    trackEvent('#footer .-facebook', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'facebook' });
    trackEvent('#footer .-email', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'emailcontato' });
    trackEvent('#footer .-english', 'click', { 'event_category': page, 'event_action': 'footer', 'event_label': 'englishversion' });

    trackEvent('main.-home .-about-leadership', 'click', { 'event_category': page, 'event_action': 'about', 'event_label': 'aboutleadership' });
    trackEvent('main.-home .-about-community', 'click', { 'event_category': page, 'event_action': 'about', 'event_label': 'aboutcommunity' });
    trackEvent('main.-home .-about-works', 'click', { 'event_category': page, 'event_action': 'about', 'event_label': 'aboutworks' });

    trackEvent('main.-home #feed-related .block-title a', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'irparaofeeed' });
    trackEvent('main.-home #feed-related .more', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'vermais' });
    trackEvent('main.-home #feed-related .slide a', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': '' }, (el, data) => data.event_label = $(el).attr('href'));

    trackEvent('main.-home #works .block-title a', 'click', { 'event_category': page, 'event_action': 'trabalhos', 'event_label': 'irparatrabalhos' });
    trackEvent('main.-home #works [data-component="card-work"] a', 'click', { 'event_category': page, 'event_action': 'trabalhos', 'event_label': '' }, (el, data) => data.event_label = $(el).attr('href'));
    trackEvent('main.-home #works .more', 'click', { 'event_category': page, 'event_action': 'trabalhos', 'event_label': 'vertodosostrabalhos' });

    trackEvent('main.-works [data-component="card-work"] a', 'click', { 'event_category': page, 'event_action': 'card', 'event_label': '' }, (el, data) => data.event_label = $(el).attr('href'));

    trackEvent('main.-works-internal #feed-related .block-title a', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'irparaofeeed' });
    trackEvent('main.-works-internal #feed-related .more', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'vermais' });
    trackEvent('main.-works-internal #feed-related .slide a', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': '' }, (el, data) => data.event_label = $(el).attr('href'));

    trackEvent('main.-works-internal h1 a', 'click', { 'event_category': page, 'event_action': 'trabalhos', 'event_label': 'irparatrabalhos' });
    trackEvent('main.-works-internal .share .twitter', 'click', { 'event_category': page, 'event_action': 'trabalhos', 'event_label': 'sharetwitter' });
    trackEvent('main.-works-internal .share .facebook', 'click', { 'event_category': page, 'event_action': 'trabalhos', 'event_label': 'sharefacebook' });
    trackEvent('main.-works-internal .share .copiar', 'click', { 'event_category': page, 'event_action': 'trabalhos', 'event_label': 'share' });

    trackEvent('main.-feeed [data-component="card-feed"] a', 'click', { 'event_category': page, 'event_action': 'card', 'event_label': '' }, (el, data) => data.event_label = $(el).attr('href'));

    trackEvent('main.-feeed-internal #feed-related .block-title a', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'irparaofeeed' });
    trackEvent('main.-feeed-internal #feed-related .more', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'vermais' });
    trackEvent('main.-feeed-internal #feed-related .slide a', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': '' }, (el, data) => data.event_label = $(el).attr('href'));

    trackEvent('main.-feeed-internal h1 a', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'irparafeeed' });
    trackEvent('main.-feeed-internal .share .twitter', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'sharetwitter' });
    trackEvent('main.-feeed-internal .share .facebook', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'sharefacebook' });
    trackEvent('main.-feeed-internal .share .copiar', 'click', { 'event_category': page, 'event_action': 'feeed', 'event_label': 'share' });

    trackEvent('main.-people .-join-to-us', 'click', { 'event_category': page, 'event_action': 'juntese', 'event_label': 'comunidade' });
    trackEvent('main.-people .-community', 'click', { 'event_category': page, 'event_action': 'click', 'event_label': 'comunidade' });
    trackEvent('main.-people .-opportunity', 'click', { 'event_category': page, 'event_action': 'oportunidades', 'event_label': '' }, (el, data) => data.event_label = $(el).text());

    trackEvent('[data-component="video-home"] .btn-play', 'click', { 'event_category': page, 'event_action': 'destaque', 'event_label': 'playvideo'  });
})(window, document, undefined);
